import React from 'react'
import { Card, CARD_ELEVATION, CARD_PADDING_SIZE } from 'components/Card'
import { Box, Flex } from 'components/Layout'
import { Text } from 'components/Typography'
import { COLOR_NAMES, FONT_SIZE, FONT_WEIGHT, SPACE } from 'Theme'
import { ExpertTeamMemberInvite } from './ExpertTeamMemberInvite'

export const ExpertTeamMemberInviteWidget = () => (
  <Card
    flexDirection="column"
    width="100%"
    elevation={CARD_ELEVATION.NONE}
    hasBorders
    paddingSize={CARD_PADDING_SIZE.NONE}
  >
    <Flex flexDirection="column">
      <Box p={SPACE.PX_30} pb={0}>
        <Text
          fontSize={FONT_SIZE.PX_22}
          color={COLOR_NAMES.PINEY_LAKE}
          fontWeight={FONT_WEIGHT.MEDIUM}
          as="h2"
        >
          Invite a Team Member
        </Text>
        <Text
          fontSize={FONT_SIZE.PX_16}
          color={COLOR_NAMES.EEIRE_BLACK}
          fontStyle="italic"
        >
          Adding team members to your account enable them to experience the same
          trade perks, discounts, and tax exemption status.
        </Text>
      </Box>
      <ExpertTeamMemberInvite customButtonLabel="Invite Team Member" />
    </Flex>
  </Card>
)
